
import { useState } from 'react';
import Search from '../../components/Search';
import SLink from '../../components/SLink';
import useDBO from '../../hooks/useDBO';
import Loading from '../../components/Loading';
import Error from '../../components/Error';
import Info from '../../components/Info';
import Lang from '../../components/Lang';
  
  export default function StoppedSearch() {
    const [search, setSearch] = useState("")

  
 

    return (<div>
      <Search search={search} setSearch={setSearch} />
    <div>
    {search && <DrawSearch search={search} />}
    </div>

  </div>)
};
  

function DrawSearch({ search }) {
  
  const data = useDBO(`/search-stopped/${search}`)
  if (data.loading) return <Loading />
  if(data.error) return <Error />

  return (
    <div>
      {data.map((student) => (
        <div style={{ display: "flex", borderBotton: "1px solid #888", padding: 5 }}>
          <div style={{ width: 300, minWidth: 300 }}>
            <SLink
              id={student._id}
              showPhone
              showClasses
              status
            />
          </div>
          <div style={{ width: 100, minWidth: 100 }}>
            <Info
              title={<Lang w="startDate" />}
              body={new Date(student.startDate).fDate()}
            />
          </div>
          <div style={{ width: 100, minWidth: 100 }}>
            <Info
              title={<Lang w="stoppedDate" />}
              body={new Date(student.statusChanged).fDate()}
            />
          </div>
          <div style={{flexGrow:1}}>
            <Info
              title={<Lang w="reason" />}
              body={
                student.statusHistory && student.statusHistory.length > 1
                  ? student.statusHistory.getLast().reason
                  : student.leaveReason
              }
            />
          </div>
        </div>
      ))}
    </div>
  );
}